import React from "react";
import { connect } from "react-redux";
import {
  getspecificSingleProductbyname,
  getspecificSingleProductbyProductCode,
} from "../../../actions/singleProductAction";
import { getspecificproductvariation } from "../../../actions/variableProductAction";
import {
  Layout,
  Breadcrumb,
  Row,
  Col,
  Select,
  Divider,
  AutoComplete,
  Form,
} from "antd";
const { Option } = Select;

const product_code = ({
  getspecificSingleProductbyProductCode,
  getspecificproductvariation,
  setvariations,
  setproducts,
  setloading,
}) => {
  const onKeyUp = (event) => {
    if (event.keyCode == 13) {
      setproducts([]);
      setvariations([]);
      setloading(true);
      getspecificSingleProductbyProductCode(event.target.value).then(
        (product) => {
          // console.log(product);
          if (product.count > 0) {
            setproducts(product.results);
            setloading(false);
          } else {
            alert("No product found with this code");
          }
        }
      );
    }
  };
  return (
    <>
      <h3>Product code</h3>
      <AutoComplete
        // ref={BarcodeInput}
        placeholder="input search text"
        // onChange={onChange}
        onKeyUp={onKeyUp}
        style={{ width: "100%" }}
      />
    </>
  );
};

export default connect(null, {
  getspecificproductvariation,
  getspecificSingleProductbyProductCode,
})(product_code);
